<template>
  <div style="width:100%; padding-top: 60px">
    <div style="position: fixed;background-color: white;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="goBack">返回</van-button>
        <screenButton class="screenButton"></screenButton>
      </div>
    </div>

    <b-table class="bgc-dark" head-variant="dark" responsive bordered
             :items="items" :fields="filterFields" :tbody-tr-class="rowClass">
      <template v-slot:head()="scope">
        <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
          {{ scope.label }}
        </div>
      </template>
      <template v-slot:cell(index)="data">
        {{ data.index + 1 }}
      </template>
      <template v-slot:cell(name)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.name)">{{ data.item.name }}</div>
      </template>
      <template v-slot:cell(remark)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.remark)">{{ data.item.remark }}</div>
      </template>
      <template v-slot:cell(packModel)="data">
        <div style="color: #4caedc" @click="showDetail(data.item.packModel)">{{ data.item.packModel }}</div>
      </template>

      <template v-slot:cell(totalWeightIncludePack)="data">
        <div>{{ Number(data.item.totalWeightIncludePack).toFixed(2) }}</div>
      </template>
      <template v-slot:cell(totalPackWeight)="data">
        <div>{{ Number(data.item.totalPackWeight).toFixed(4) }}</div>
      </template>
      <template v-slot:cell(totalWeightExcludePack)="data">
        <div>{{ Number(data.item.totalWeightExcludePack).toFixed(4) }}</div>
      </template>


      <template v-slot:table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
        >
      </template>
    </b-table>
  </div>
</template>

<script>

export default {
  name: "ItsWaybillDetailSecond",
  data() {
    return {
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'brandName', label: '产品品牌', width: '140px'},
        {key: 'varietyLevelLabel', label: '产品等级', width: '120px'},
        {key: 'totalWeightIncludePack', label: '含筐总重（斤）', width: '120px'},
        {key: 'truckNum', label: '装车件数（筐）', width: '120px'},
        {key: 'packModel', label: '塑料筐规格', width: '140px'},
        {key: 'totalPackWeight', label: '装车包装物重量（斤）', width: '120px'},
        {key: 'totalWeightExcludePack', label: '不含筐净重（斤）', width: '120px'},
        {key: 'remark', label: '备注', width: '120px'},
      ],
      items: [],
      category: ''
    }
  },
  created() {
    this.items = JSON.parse(this.$route.query.data)
    this.category = this.$route.query.category
  },
  computed: {
    filterFields() {
      if(this.category === '2') {
        return [
          {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
          {key: 'brandName', label: '产品品牌', width: '140px'},
          {key: 'varietyLevelLabel', label: '产品等级', width: '120px'},
          {key: 'totalWeightIncludePack', label: '含筐总重（斤）', width: '120px'},
          {key: 'truckNum', label: '装车件数（筐）', width: '120px'},
          {key: 'packModel', label: '塑料筐规格', width: '120px'},
          {key: 'remark', label: '备注', width: '120px'},
        ]
      } else {
        return [
          {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
          {key: 'varietyLevelLabel', label: '产品等级', width: '120px'},
          {key: 'totalWeightIncludePack', label: '含筐总重（斤）', width: '120px'},
          {key: 'truckNum', label: '装车件数（筐）', width: '120px'},
          {key: 'packModel', label: '塑料筐规格', width: '120px'},
          {key: 'totalPackWeight', label: '装车包装物重量（斤）', width: '120px'},
          {key: 'totalWeightExcludePack', label: '不含筐净重（斤）', width: '120px'},
          {key: 'remark', label: '备注', width: '120px'},
        ]
      }
    }
  },
  methods: {
    init() {

    },
    goBack() {
      this.$router.back()
    },
    showDetail(content) {
      if (content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
    rowClass() {
      return 'row-center'
    },
  }
}
</script>

<style scoped>
::v-deep .row-center td {
  vertical-align: middle;
}
</style>
